import React from 'react';

const NotFound = () => {
  const styles = {
    container: {
      fontFamily: 'arial, sans-serif',
      margin: '50px auto',
      maxWidth: '600px',
      padding: '20px',
      textAlign: 'center'
    },
    logo: {
      maxWidth: '150px',
      height: 'auto',
      marginBottom: '30px'
    },
    errorCode: {
      fontSize: '40px',
      color: '#222',
      marginBottom: '10px',
      fontWeight: 700
    },
    errorTitle: {
      fontSize: '18px',
      color: '#222',
      marginBottom: '20px'
    },
    errorMessage: {
      fontSize: '13px',
      color: '#222',
      lineHeight: '1.4'
    }
  };

  return (
    <div style={styles.container}>
      <img
        src="/images/LOGO.png"
        alt="Logo"
        style={styles.logo}
        onError={(e) => { e.currentTarget.style.display = 'none'; }}
      />
      <div style={styles.errorCode}>404.</div>
      <div style={styles.errorTitle}>That's an error.</div>
      <div style={styles.errorMessage}>
        <p>The requested URL was not found :(</p>
      </div>
    </div>
  );
};

export default NotFound;
